import { getWithRedirect } from 'utils/axios'

const BASE_URL =
  process.env.NODE_ENV === 'development'
    ? 'http://localhost:3990/'
    : process.env.REACT_APP_HOMEPAL_MDM_API_PROD

/**
 * link_to_source values on this format point at files that must be
 * fetched from the source system with credentials. The backend
 * returns the file base64 encoded — the link is never opened
 * directly.
 *
 * Format: homepal-file://<resource>/<file_id>?active_source_id=<uuid>
 */
export const SOURCE_FILE_LINK_PREFIX = 'homepal-file://'

export function isSourceFileLink(link: string): boolean {
  return link.startsWith(SOURCE_FILE_LINK_PREFIX)
}

type SourceFileResponse = {
  base64: string
  content_type: string
  filename: string
}

/**
 * Resolve a source file link through the backend and trigger a
 * download of the file in the browser.
 */
export async function downloadSourceFile(link: string): Promise<void> {
  const response = await getWithRedirect<SourceFileResponse>(
    `${BASE_URL}v1/source-files?link=${encodeURIComponent(link)}`
  )

  const { base64, content_type: contentType, filename } = response.data.data

  const bytes = window.atob(base64)
  const buffer = new Uint8Array(bytes.length)

  for (let i = 0; i < bytes.length; i++) {
    buffer[i] = bytes.charCodeAt(i)
  }

  const blob = new Blob([buffer], { type: contentType })
  const url = window.URL.createObjectURL(blob)

  const anchor = document.createElement('a')

  anchor.href = url
  anchor.download = filename
  document.body.appendChild(anchor)
  anchor.click()
  document.body.removeChild(anchor)
  window.URL.revokeObjectURL(url)
}
